import React from 'react'
import { Avatar, Box, Text } from '@chakra-ui/react';

const UserListItem = ({ user, handleFunction }) => {
  return (
    <Box
      onClick={handleFunction}
      cursor={"pointer"}
      bg={"#A9A9A9"}
      _hover={{
        background: "grey",
        color: "white",
      }}
      w={"100%"}
      display={"flex"}
      alignItems={"center"}
      color={"black"}
      px={3}
      py={2}
      mb={2}
      borderRadius={"lg"}
    >
      <Avatar
        mr={2}
        size={"sm"}
        cursor={"pointer"}
        name={user.name}
        src={user.pic} />

      <Box>
        <Text>{user.name}</Text>
        <Text>
          <b>Email :</b>
          {user.email}
        </Text>
      </Box>
    </Box>
  )
}

export default UserListItem
